import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import LandingPage from '../LandingPage';
import DoctorLandingPage from './DoctorLandingPage';

const RoleLandingPage = () => {
    const { user } = useAuth();

    if (user?.role === 'Doctor' || user?.role === 'Medical Director') {
        return <DoctorLandingPage />;
    }

    return <LandingPage />;
};

export default RoleLandingPage;
